import { createStore, compose, applyMiddleware } from "redux";
import { logger } from "redux-logger";
import rootReducer from "./redux/rootReducer";

const enhancers = [
  process.env.NODE_ENV !== "production" && applyMiddleware(logger),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
].filter(Boolean);
const store = compose(...enhancers)(createStore)(rootReducer);

export default store;
